import React, { useState } from "react";
import styles from "./DataControls.module.css";
import Button from "../../../Button/Button";
import ModalBlackBgTemplate from "../../../ModalBlackBgTemplate/ModalBlackBgTemplate";
import { ReactComponent as WhiteLock } from "../../../../assets/WhiteLock.svg";

import HeaderCard from "../../../HeaderCard/HeaderCard";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const DataControls = ({ setShowImportContacts, setDeleteChats,setTypeDelete,setShowSidebar }) => {
  const [t] = useTranslation('accountSetting')


  const close = () => {
    setDeleteChats(false);
  };

  const navigate = useNavigate();
  return (
    <div>
      <div className={styles.labelGeneral}>
        <p>{t('exportData')}</p>{" "}
        <Button
          type="white"
          action={() => {
            navigate("/admin/contacts", { state: { showImport: true } });
          }}
        >
          {t('export')}
        </Button>
      </div>
      <div className={styles.labelGeneral}>
        <p>{t('exportContacts')}</p>{" "}
        <Button
          type="white"
          action={() => {
            navigate("/admin/contacts", { state: { showImport: true } });
            setShowSidebar(false)
          }}
        >
           {t('export')}
        </Button>
      </div>
      <div className={styles.labelGeneral}>
        <p>{t('exportAssets')}</p>{" "}
        <Button
          type="white"
          action={() => {
            navigate("/admin/assets", { state: { showImport: true } });
            setShowSidebar(false)
          }}
        >
           {t('export')}
        </Button>
      </div>
      <div className={styles.labelGeneral}>
        <p>{t('deleteAccount')}</p>{" "}
        <Button
          type="discard"
          headerStyle={{ background: "#DC3545", borderRadius: "999px" }}
          action={() => {
            setTypeDelete('account')
            setDeleteChats(true)
          }}
        >
          {t('delete')}
        </Button>
      </div>
      <div className={styles.labelGeneral}>
          <p>{t('deleteAllContacts')}</p>
          <Button
            action={() => {
              setDeleteChats(true)
              setTypeDelete('contacts')
            }}
            type="discard"
            headerStyle={{
              background: "#DC3545",
              borderRadius: " 9999px",
            }}
          >
            {t('deleteAll')}
          </Button>
      </div>

      <div className={styles.labelGeneral}>
          <p>{t('deleteAllAssets')}</p>
          <Button
              action={() => {
                setDeleteChats(true)
                setTypeDelete('assets')
              }}
            type="discard"
            headerStyle={{
              background: "#DC3545",
              borderRadius: " 9999px",
            }}
          >
            {t('deleteAll')}
          </Button>
      </div>


      <div className={styles.labelGeneral}>
          <p>{t('deleteAllNotifications')}</p>
          <Button
             action={() => {
              setDeleteChats(true)
              setTypeDelete('notifications')
            }}
            type="discard"
            headerStyle={{
              background: "#DC3545",
              borderRadius: " 9999px",
            }}
          >
            {t('deleteAll')}
          </Button>
      </div>


      <div className={styles.labelGeneral}>
          <p>{t('deleteAll')}</p>
          <Button
             action={() => {
              setDeleteChats(true)
              setTypeDelete('allUserInformation')
            }}
            type="discard"
            headerStyle={{
              background: "#DC3545",
              borderRadius: " 9999px",
            }}
          >
            {t('deleteAll')}
          </Button>
      </div>



    </div>
  );
};

export default DataControls;
